import React from 'react';

export const ModalContext = React.createContext<any | undefined>(undefined);
